import { type RouteRecordRaw } from 'vue-router';

import { License } from '../../models';

export const schedulingRoutes: RouteRecordRaw[] = [{
    path: 'scheduling',
    name: 'scheduling',
    redirect: { name: 'scheduling.plannings' },
    meta: {
        showInMenu: true,
        hasTabs: true,
        categoryIndex: 4,
        index: 0,
        licenses: {
            operator: 'or',
            licenses: [License.SPOT_AUDIO, License.SPOT_SCENT, License.SPOT_VIDEO]
        },
        prependIcon: 'icon-tag',
        code: 'core.routes.menu.scheduling'
    },
    component: () => import('./views/SchedulingView.vue'),
    children: [{
        path: 'scheduling/plannings',
        name: 'scheduling.plannings',
        meta: {
            showInTabs: true,
            index: 0,
            code: 'core.routes.scheduling.plannings'
        },
        component: () => import('./views/scheduling/PlanningsView.vue')
    }, {
        path: 'scheduling/events',
        name: 'scheduling.events',
        meta: {
            showInTabs: true,
            index: 1,
            code: 'core.routes.scheduling.events'
        },
        component: () => import('./views/scheduling/EventsView.vue')
    }]
}, {
    path: 'scheduling/plannings',
    name: 'plannings',
    redirect: { name: 'plannings.plannings' },
    meta: {
        showInMenu: true,
        hasTabs: true,
        categoryIndex: 4,
        index: 1,
        licenses: {
            operator: 'or',
            licenses: [License.SPOT_AUDIO, License.SPOT_SCENT, License.SPOT_VIDEO]
        },
        prependIcon: 'icon-schedule',
        code: 'core.routes.menu.plannings'
    },
    component: () => import('./views/PlanningsView.vue'),
    children: [{
        path: 'plannings/:planningId/edit',
        name: 'plannings.edit-planning',
        meta: {
            code: 'core.routes.plannings.edit-planning',
            hideTabs: true,
            breadcrumbs: true
        },
        component: () => import('./views/plannings/EditPlanningView.vue')
    }, {
        path: 'plannings/:planningId/:timeFrame/:date',
        name: 'plannings.planning',
        meta: {
            code: 'core.routes.plannings.planning',
            hideTabs: true,
            breadcrumbs: true
        },
        component: () => import('./views/plannings/PlanningView.vue')
    }, {
        path: 'children/:planningId/:timeFrame/:date',
        name: 'plannings.children-planning',
        meta: {
            code: 'core.routes.plannings.children-planning',
            hideTabs: true,
            breadcrumbs: true
        },
        component: () => import('./views/plannings/ChildrenPlanningView.vue')
    }, {
        path: 'plannings',
        name: 'plannings.plannings',
        meta: {
            showInTabs: true,
            index: 0,
            code: 'core.routes.plannings.plannings'
        },
        component: () => import('./views/plannings/PlanningsView.vue')
    }, {
        path: 'shared/:planningId/:timeFrame/:date',
        name: 'plannings.shared-planning',
        meta: {
            code: 'core.routes.plannings.shared-planning',
            hideTabs: true,
            breadcrumbs: true
        },
        component: () => import('./views/plannings/SharedPlanningView.vue')
    }, {
        path: 'shared',
        name: 'plannings.shared',
        meta: {
            showInTabs: true,
            index: 1,
            code: 'core.routes.plannings.shared'
        },
        component: () => import('./views/plannings/SharedView.vue')
    }, {
        path: 'favorites',
        name: 'plannings.favorites',
        meta: {
            showInTabs: true,
            index: 2,
            code: 'core.routes.plannings.favorites'
        },
        component: () => import('./views/plannings/FavoritesView.vue')
    }]
}, {
    path: 'scheduling/events',
    name: 'events',
    redirect: { name: 'events.events' },
    meta: {
        showInMenu: true,
        hasTabs: true,
        categoryIndex: 4,
        index: 2,
        licenses: {
            operator: 'or',
            licenses: [License.SPOT_AUDIO, License.SPOT_SCENT, License.SPOT_VIDEO]
        },
        prependIcon: 'icon-event',
        code: 'core.routes.menu.events'
    },
    component: () => import('./views/EventsView.vue'),
    children: [{
        path: 'events/:eventId/edit',
        name: 'events.edit-event',
        meta: {
            code: 'core.routes.events.edit-event',
            hideTabs: true,
            breadcrumbs: true
        },
        component: () => import('./views/events/EditEventView.vue')
    }, {
        path: 'events/:eventId/:timeFrame/:date',
        name: 'events.event',
        meta: {
            code: 'core.routes.events.event',
            hideTabs: true,
            breadcrumbs: true
        },
        component: () => import('./views/events/EventView.vue')
    }, {
        path: 'children/:eventId/:timeFrame/:date',
        name: 'events.children-event',
        meta: {
            code: 'core.routes.events.children-event',
            hideTabs: true,
            breadcrumbs: true
        },
        component: () => import('./views/events/ChildrenEventView.vue')
    }, {
        path: 'events',
        name: 'events.events',
        meta: {
            showInTabs: true,
            index: 0,
            code: 'core.routes.events.events'
        },
        component: () => import('./views/events/EventsView.vue')
    }, {
        path: 'shared/:eventId/:timeFrame/:date',
        name: 'events.shared-event',
        meta: {
            code: 'core.routes.events.shared-event',
            hideTabs: true,
            breadcrumbs: true
        },
        component: () => import('./views/events/SharedEventView.vue')
    }, {
        path: 'shared',
        name: 'events.shared',
        meta: {
            showInTabs: true,
            index: 1,
            code: 'core.routes.events.shared'
        },
        component: () => import('./views/events/SharedView.vue')
    }, {
        path: 'favorites',
        name: 'events.favorites',
        meta: {
            showInTabs: true,
            index: 2,
            code: 'core.routes.events.favorites'
        },
        component: () => import('./views/events/FavoritesView.vue')
    }]
}, {
    path: 'scheduling/broadcast',
    name: 'broadcast',
    meta: {
        showInMenu: true,
        categoryIndex: 4,
        index: 3,
        licenses: {
            operator: 'or',
            licenses: [License.SPOT_AUDIO, License.SPOT_SCENT, License.SPOT_VIDEO]
        },
        prependIcon: 'icon-broadcast',
        code: 'core.routes.menu.broadcast'
    },
    component: () => import('./views/BroadcastView.vue')
}];